<template>
    <div class="dropdown-component" v-show="open" ref="dropdownComponent">
        <ul class="dropdown-list">
            <li
                v-for="element in elements"
                @click.stop="changePage(element)"
                :key="element.handle">
                <span>{{ element.handleName }}</span>
            </li>
        </ul>
    </div>
</template>

<script>
import Vue from 'vue'
import { MdIcon } from 'vue-material/dist/components'

Vue.use(MdIcon)

export default {
    name: 'NavDropdown',
    props: ['open', 'elements'],

    data() {
        return {}
    },

    watch: {
        open: {
            handler: function(val) {
                if (val) {
                    this.checkPosition()
                }
            }
        }
    },

    methods: {
        changePage(element) {
            this.$emit('clicked', element.handle);
        },
        checkPosition() {
            let el = this.$refs.dropdownComponent

            setTimeout(function() {
                let rect = el.getBoundingClientRect()
                if (window.innerHeight < rect.bottom + 5) {
                    el.classList.add('bottom')
                }
            }, 1)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/sass/toolkit.scss';
@import '../assets/sass/ui/input.scss';

.dropdown-component {
    position: absolute;
    text-transform: uppercase;
    font-weight: bold;
    width: 150px;
    top: 50px;

    &.bottom {
        top: auto;
        bottom: 5px;
    }

    .dropdown-list {
        top: 0;
        position: relative;
        border-radius: 2px;
        background: $color-white;
        z-index: 100;

        li {
            display: flex;
            font-size: 11px;
            line-height: 19px;
            padding: 12px 22px;
            vertical-align: middle;

            i {
                position: relative;
                line-height: 15px;
                height: 14px;
                width: 14px;
                top: 3px;
                margin-right: 7px;
            }
        }
    }
}
</style>
